<div class="user-card">
    <div class="user-img">
        <img *ngIf="option['mediaId']" class="suggestion-picture" [src]="getGuestImageSrc(option['mediaId'])" alt="Suggestion">
        <div *ngIf="isOnWatchlist" class="denied-status"
            tooltip="On Watchlist"
            container="body"></div>
    </div>

    <div class="ellipsis">
        <div class="name ellipsis" [innerHTML]="(option['contractorName'] ? option['contractorName'] : option['fullName']) | htmltransfrom | highlight: query"></div>
        <div class="email ellipsis" [innerHTML]="(option['contractorName'] ? option['personId'] : option['email']) | htmltransfrom | highlight: query"></div>
    </div>
</div>
